import React, { use } from 'react';

import LinkButton from 'src/components/facilities/link-button';
import { ClubCmsContent } from 'src/content/club-content-consumer';
import { GlobalCmsContent } from 'src/content/global-content';
import { SiteContext } from 'src/context/site-context';
import { ButtonStyle } from 'src/enums/button-style';

type EnquireNowButtonProps = {
  buttonType?: string;
  gtmTrackingId: string;
  buttonStyle?: ButtonStyle;
};

const EnquireNowButton = ({ buttonType, gtmTrackingId, buttonStyle }: EnquireNowButtonProps) => {
  const clubCmsData = use(ClubCmsContent);
  const globalCmsData = use(GlobalCmsContent);
  const { isGlobalPage } = use(SiteContext);

  const enquireNowButtonContent = isGlobalPage
    ? { ...globalCmsData.sharedContent.enquireNowButton, goToGlobal: true }
    : clubCmsData.sharedContent.enquireNowButton;

  return (
    <LinkButton
      buttonText={enquireNowButtonContent?.enquireNowButtonText}
      buttonKey="enquireNow"
      buttonLink={enquireNowButtonContent?.enquireNowButtonLink}
      buttonType={buttonType}
      buttonStyle={buttonStyle || ButtonStyle.PRIMARY}
      gtmTrackingId={gtmTrackingId}
      goToGlobal={enquireNowButtonContent?.goToGlobal}
    />
  );
};

export default EnquireNowButton;
